import { render, staticRenderFns } from "./DynamicFormQuestionsTable.vue?vue&type=template&id=317d15c8&"
import script from "./DynamicFormQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./DynamicFormQuestionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports